export default {
  api_key: 'P5cMjbj5f5GP3FH=*Y9DskC8_EL2*AsX',
  apple_app_link: 'https://testflight.apple.com/join/ABxBWw2O',
  domain: 'narative.io',
  machine_env: 'production',
  version: '165'
}
